@if (site) {
  <mat-accordion>
    <!-- Storage Panel -->
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <div class="flex items-center">
          <h2 style="margin-right: 1rem">Battery</h2>
        </div>
      </mat-expansion-panel-header>
      <app-site-operations-battery [site]="site"></app-site-operations-battery>
    </mat-expansion-panel>
  </mat-accordion>
} @else {
  <div class="flex items-center justify-center">
    <span style="margin-top: 5rem">Controls hidden - Site data did not load.  If problem persists after refreshing, please contact an admin.</span>
  </div>
}
